import Icon from '@ant-design/icons';
import classNames from 'classnames';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

import RightSvg from '@/components/Icon/svgs/right.svg';

interface IProps {
  className?: string;
  handleClick?: () => void;
}

const RouterBackIcon = (props: IProps) => {
  const { className, handleClick: manualControl } = props;
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleClick = useCallback(() => {
    if (manualControl) {
      manualControl();

      return;
    }

    const rollbackUrl = searchParams.get('rollback');

    if (rollbackUrl) {
      router.push(decodeURIComponent(rollbackUrl));
    } else {
      router.back();
    }
  }, [manualControl, searchParams, router]);

  return (
    <div
      className={classNames(
        'w-9 h-9 bg-[rgba(254,253,255,0.6)] rounded-[18px] p-1 cursor-pointer hover:bg-[rgba(254,253,255,0.8)] transition-all duration-200',
        className
      )}
      data-role="edit-ignore-blur"
      onClick={handleClick}
    >
      <Icon className="text-[28px] text-primary-black" component={RightSvg} rotate={180} />
    </div>
  );
};

export default RouterBackIcon;
